import React, { useContext, useState, useEffect } from "react"
import arrowLeft from "./../../images/home/arrowLeft.jpg"
import arrowRigth from "./../../images/home/arrowRigth.jpg"
import TargetWork from "./TargetWork"
import { LoadingContext } from "../../components/context/LoadingContext"
import i18n from "i18next"
import { Link } from "gatsby"
import { getOffers } from "./../../utils/api"
import { getOffersById } from "./../../utils/api.js"

const JoinOurTeamHome = () => {
  const { windowWidth } = useContext(LoadingContext)

  const [initialValue, setInitialValue] = useState(0)
  const [finalValue, setFinalValue] = useState(3)
  const [jobs, setJobs] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getJobs()
  }, [i18n.language])

  useEffect(() => {
    getJobs()
  }, [])

  async function getJobs() {
    try {
      const response = await getOffers() // Obtiene los datos de trabajo
      const jobsWithTime = await Promise.all(
        response.data.obj.map(async job => {
          const jobInfo = await getJobInfoById(job.jobId) // Obtién la información completa del trabajo por su ID
          const time =
            jobInfo?.jobLocationModality?.name ||
            i18n.t("pagejoinourteam.vacancies.nodata")
          const descriptionVacant = convertDescription(jobInfo?.description)
          return {
            ...job,
            time: time,
            descriptionJob: descriptionVacant,
          }
        })
      )
      setJobs(jobsWithTime.slice(0, 9))
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  }

  async function getJobInfoById(jobId) {
    try {
      const response = await getOffersById(jobId)
      const jobInfo = response.data.obj
      const time =
        i18n.language === "en"
          ? jobInfo?.jobLocationModality?.nameEnglish
          : jobInfo?.jobLocationModality?.name
      const descriptionVacant = convertDescription(jobInfo?.description)
      return {
        ...jobInfo,
        time: time || i18n.t("pagejoinourteam.vacancies.nodata"),
        descriptionJob: descriptionVacant,
      }
    } catch (error) {
      console.log(error)
      return null
    }
  }

  function convertDescription(descri) {
    const descriptionWithoutHTML = descri.replace(/<[^>]+>/g, "")
    const words = descriptionWithoutHTML.split(/\s+/)
    const truncatedDescription = words.slice(0, 45).join(" ")
    const ellipsis = words.length > 55 ? "..." : ""

    return `${truncatedDescription}${ellipsis}`
  }

  function handleBefore() {
    if (initialValue == 0) {
      setInitialValue(jobs.length - 3)
      setFinalValue(jobs.length)
    } else {
      setInitialValue(initialValue - 3)
      setFinalValue(finalValue - 3)
    }
  }

  function handleAfter() {
    if (finalValue == jobs.length) {
      setInitialValue(0)
      setFinalValue(3)
    } else {
      setInitialValue(initialValue + 3)
      setFinalValue(finalValue + 3)
    }
  }

  return (
    <div className="mobile:w-full desktop:pl-8 desktop:pr-4 mobile:pl-4 mobile:pr-4 flip-card pyWork">
      <div className="flip-card-inner2 desktop:ml-16 mt-24">
        <div className="">
          <p className="subTitleOurServices">
            {i18n.t("home.vacanciesHome.title")}
          </p>
          {windowWidth >= 1025 ? (
            <div className="flex">
              {i18n.language == "en" ? (
                <>
                  <p className="titleOurServices">E</p>
                  <p className="titleOurServices colorEx">x</p>
                  <p className="titleOurServices">
                    ceed your potential with us
                  </p>
                </>
              ) : (
                <>
                  <p className="titleOurServices">Trabaja con nosotros</p>{" "}
                </>
              )}
            </div>
          ) : (
            <div className="">
              {i18n.language == "en" ? (
                <>
                  <div className="flex">
                    <p className="titleOurServices">E</p>
                    <p className="titleOurServices colorEx">x</p>
                    <p className="titleOurServices">ceed your </p>
                  </div>
                  <p className="titleOurServices">potential with us</p>
                </>
              ) : (
                <>
                  <p className="titleOurServices">Trabaja con nosotros</p>{" "}
                </>
              )}
            </div>
          )}
        </div>
        <div className="desktop:flex desktop:mr-20 bigdesktop:mr-40 ">
          <div>
            {windowWidth >= 1025 ? (
              <p className="textCoreSolutions desktop:text-20 mobile:text-16 desktop:text-left  mb-8 mobile:px-6">
                {i18n.t("home.vacanciesHome.text")}
              </p>
            ) : (
              <p className="textCoreSolutionsMobile desktop:text-20 mobile:text-16 text-left  mb-8 ">
                {i18n.t("home.vacanciesHome.text")}
              </p>
            )}
          </div>
          {windowWidth >= 1025 ? (
            <div className="flex ml-auto mt-4 mb-4">
              <button className="mobile:ml-auto" onClick={() => handleBefore()}>
                <img
                  src={arrowLeft}
                  alt="Imagen PopUp"
                  className="mt-1 desktop:mr-8 mobile:mr-24"
                />
              </button>
              <button className="mobile:mr-auto" onClick={() => handleAfter()}>
                <img src={arrowRigth} alt="Imagen PopUp" className="" />
              </button>
            </div>
          ) : null}
        </div>

        {isLoading ? (
          <div className="">
            <p className="resultsSearch mt-10 mobile:w-full desktop:pl-8 desktop:pr-4 mobile:pl-4 mobile:pr-4 ">
              {i18n.t("pagejoinourteam.vacancies.loading")}
            </p>
          </div>
        ) : (
          <TargetWork
            workArray={jobs}
            finalValue={finalValue}
            initialValue={initialValue}
          />
        )}

        {windowWidth < 1025 ? (
          <div className="flex ml-auto mobile:mt-12">
            <button className="mobile:ml-auto" onClick={() => handleBefore()}>
              <img
                src={arrowLeft}
                alt="Imagen PopUp"
                className="mt-1 desktop:mr-8 mobile:mr-24"
              />
            </button>
            <button className="mobile:mr-auto" onClick={() => handleAfter()}>
              <img src={arrowRigth} alt="Imagen PopUp" className="" />
            </button>
          </div>
        ) : null}

        <Link to={"/exceptional-careers"}>
          <button
            className={
              windowWidth >= 1025
                ? "buttonViewMoreWork ml-auto mr-auto mt-12"
                : "contentButtomViewAllMobile ml-auto mr-auto mt-12"
            }
            style={{ alignSelf: "center" }}
          >
            <p
              className={
                windowWidth >= 1025
                  ? "textButtomViewMoreWork"
                  : "colorTextAllServicesMobile"
              }
            >
              {i18n.t("home.vacanciesHome.bottom")}
            </p>
          </button>
        </Link>
      </div>
    </div>
  )
}

export default JoinOurTeamHome
